import SettingsLine from './SettingsLine';

export default SettingsLine;
